import {Breadcrumb, Tabs} from 'src/feature/bite/component'
import {StoreList} from 'src/feature/store/domain/list'

import {
  EmailEngagement,
  StoreCommissionDetail,
  StoreInvoices,
  StoreOverview,
  StoreSubscriptions,
  StoreTransactions,
  StoreUsers,
  StoreUserDetail,
} from '../component/Detail'

import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useSearchParams} from 'react-router-dom'
import {useGetDetailCorporate, useGetTabDetail} from '../context/useQuery'
import {useMerchant, useStore} from '../hook'
import StoreStores from '../component/Detail/StoreStores'
import {ProviderActivities} from 'src/feature/provider/component/Detail'
import ActivityList from 'src/feature/transaction-list/component/ActivityList'

export default function StoreDetail({storeData}: {storeData?: StoreList}) {
  const intl = useIntl()
  const [searchParams, setSearchParams] = useSearchParams()
  const {detail, tab, tabSet, tabFilter, tabFilterSet} = useStore()
  const {detail: merchantDetail} = useMerchant()
  const [search, setSearch] = useState('')

  const {isLoading} = useGetDetailCorporate()
  const {isLoading: isLoadingTab, refetch} = useGetTabDetail(detail?.id || '')

  useEffect(() => {
    if (searchParams?.get('commissionId') && tab !== 'CommissionDetail') {
      tabSet('CommissionDetail')
    }
    if (searchParams?.get('userID') && tab !== 'UserDetail') {
      tabSet('UserDetail')
    }
    if (searchParams?.get('refetch')) {
      refetch()
      searchParams.delete('refetch')
    }
  }, [searchParams, tab])

  useEffect(() => {
    if (!searchParams?.get('commissionId') && !searchParams?.get('userID')) {
      tabSet('Overview')
    }
  }, [])

  useEffect(() => {
    const tabQuery = searchParams.get('tab')
    if (tabQuery && tabQuery === 'locations') {
      tabSet('Locations')
    }
  }, [searchParams])

  const tabs = [
    {
      label: intl.formatMessage({id: 'STORE.DETAIL.OVERVIEW'}),
      key: 'Overview',
      component: <StoreOverview loading={isLoading} />,
    },
    {
      label: intl.formatMessage({id: 'STORE.LOCATIONS'}),
      key: 'Locations',
      component: <StoreStores isCorporate={true} />,
    },
    {
      label: intl.formatMessage({id: 'MENU.ACTIVITIES'}),
      key: 'Activities',
      component: <ActivityList />,
    },
    // {
    //   label: intl.formatMessage({ id: 'STORE.DETAIL.CONTACT' }),
    //   key: 'Contact',
    //   component: <StoreContact loading={isLoadingTab} />,
    // },
    {
      label: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS'}),
      key: 'Subscription',
      component: <StoreSubscriptions loading={isLoadingTab} />,
    },
    {
      label: intl.formatMessage({id: 'STORE.DETAIL.INVOICES'}),
      key: 'Invoice',
      component: <StoreInvoices loading={isLoadingTab} />,
    },
    {
      label: intl.formatMessage({id: 'STORE.DETAIL.TRANSACTIONS'}),
      key: 'Transaction',
      component: (
        <StoreTransactions storeId={storeData?.dataList?.[0]?.id} loading={isLoadingTab} />
      ),
    },
    {
      label: intl.formatMessage({id: 'STORE.DETAIL.USERS'}),
      key: 'User',
      component: <StoreUsers loading={isLoadingTab} refetch={refetch} />,
    },

    /*     {
      label: intl.formatMessage({id: 'STORE.DETAIL.ENGAGEMENT'}),
      childs: [
        {
          label: intl.formatMessage({id: 'STORE.DETAIL.EMAIL_ENGAGEMENT'}),
          key: 'EmailEngagement',
          component: <EmailEngagement loading={isLoadingTab} />,
        },
      ],
    }, */
  ]

  const findComponentByKey = (key, tabsArray) => {
    for (let item of tabsArray) {
      if (item.key === key) {
        return item.component
      }
      if (item.childs) {
        const foundChild = item.childs.find((child) => child.key === key)
        if (foundChild) {
          return foundChild.component
        }
      }
    }
    return null
  }

  const selectedComponent = findComponentByKey(tab, tabs)

  return (
    <>
      <Breadcrumb currentPage={intl.formatMessage({id: 'STORE_PLURAL'})} />

      <div className='card mb-5 mb-xl-10 mt-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='page-title d-flex flex-column justify-content-center gap-1 me-3'>
                    <h1 className='page-heading d-flex flex-column justify-content-center text-dark fw-bold fs-3 m-0'>
                      {merchantDetail?.officialName || 'Corporate Detail'}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Tabs
            tabs={tabs}
            selectedTab={tab}
            setSelectedTab={(tab) => {
              searchParams.delete('commissionId')
              searchParams.delete('userID')
              setSearchParams(searchParams)
              tabSet(tab)
              tabFilterSet({
                filterList: [],
                paging: {
                  currentPageNumber: 1,
                  pageSize: 10,
                },
              })
            }}
            loading={isLoading}
          />
        </div>
      </div>

      <div className='tab-content' id='myTabContent'>
        <div className='tab-pane fade active show' role='tabpanel'>
          <div className='card-body pt-0'>
            <div className='tab-content' id='myTabContent'>
              {selectedComponent}
              {tab === 'CommissionDetail' && <StoreCommissionDetail loading={isLoadingTab} />}
              {tab === 'UserDetail' && <StoreUserDetail loading={isLoadingTab} />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
